import { render, staticRenderFns } from "./PermissionTree.vue?vue&type=template&id=0a4c3645&scoped=true"
import script from "./PermissionTree.vue?vue&type=script&lang=js"
export * from "./PermissionTree.vue?vue&type=script&lang=js"
import style0 from "./PermissionTree.vue?vue&type=style&index=0&id=0a4c3645&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a4c3645",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a4c3645')) {
      api.createRecord('0a4c3645', component.options)
    } else {
      api.reload('0a4c3645', component.options)
    }
    module.hot.accept("./PermissionTree.vue?vue&type=template&id=0a4c3645&scoped=true", function () {
      api.rerender('0a4c3645', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/superadmin/components/PermissionTree.vue"
export default component.exports